import React from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';

/**
 * Style dependencies
 */
import './styles.scss';

// 'key' is a reserved keyword in React, so we need to use a different name (k)
const ConnectionInputRow = ({ connectionTypeCode, prefix = '', k, label, value, handleOnChange }) => {
	const name = `${prefix}${k}`;

	let helperText = undefined;

	if (k == 'domain') {
		helperText = 'Please include https:// in your domain.';
	} else if (connectionTypeCode == 'big_commerce' && k == 'StoreHash') {
		helperText = 'Contained in API Path https://api.bigcommerce.com/stores/[STORE_HASH]/v3/';
	}

	return (
		<Box key={k}>
			<FormLabel>{label}:</FormLabel>
			<FormTextInput name={name} value={value} onChange={handleOnChange} />
			{helperText && <Text className='card__section--additional-content'>{helperText}</Text>}
		</Box>
	);
};

export default ConnectionInputRow;
